import React from "react";
import "./DragFlowConveyorChain.css";
import dragimg from "./drag.jpg";

const DragFlowConveyorChain = () => {
  return (
    <div className="main-drag">
      <div className="second-drag">
        <div className="drag">
          <p>Drag / FlowConveyor Chain</p>
          <div>
            <p className="drag2">
              Swajit Engineering Pvt.Ltd.> Drag / FlowConveyor Chain
            </p>
          </div>
        </div>
        <div className="flow">
          <h1 className="best4">
            Get the Best Drag / Flow Conveyor Chain Manufacturers In India
          </h1>
          <p>
            Driven by highly qualified and skilled professionals, we at Swajit
            engineering Pvt ltd are leading one of the <b> Drag/ flow conveyor Chain
            Manufacturers in Aurangabad, Maharashtra India.</b> We have been
            offering a vast range of drag or flow conveyor chains in various
            specifications to cater to the customer’s satisfaction at each
            level. These conveyor chains are produced by our highly dedicated
            team of professionals with the highest quality finishing.
          </p>

          <div className="drag-chain">
            <img src={dragimg} alt="img"></img>

            <div className="drag-chain1">
              <div className="drag-chain2">
                <p className="">
                  Utilizing premium raw materials and ultra-modern technology,
                  we manufacture precision quality conveyor chains with high
                  accuracy for many industrial applications. According to a set
                  of industry norms and standards, our drag conveyor chains are
                  created to bring defect-free and flawless products at the
                  client end. Owing to a skillful team, modern technology, large
                  infrastructure unit, premium quality products, and business
                  ethics, we have been able to raise a huge clientele base and
                  our remarkable position in the upcoming market. Hence, our
                  organization is considered one of the best <b> Drag / Flow
                  Conveyor Chain Manufacturers in India.</b>
                  <h3>What is a Drag Chain Conveyor? Where is it used?</h3>
                  Drag chain conveyor is also known as drag conveyor or scraper
                  chain conveyors that are used to shift heavy-duty solid
                  material from one place to another. It is mainly used in bulk
                  material handling In a variety of industries such as cement,
                  chemical, power, food processing, solid waste treatment, water
                  treatment plants, mining, petrochemical, etc for the movement
                  of the materials.
                </p>
              </div>
            </div>
          </div>

          <div className="drag-chain3">
            <h3>
            What are the Top Benefits of Drag Chain Conveyor Manufacturers in India?
            </h3>
            <ul>
                <li>Provides a wide range of conveyor chains to many industries on time delivery.</li>
                <li>Ensures optimum performance with high efficiency.</li>
                <li>Having a highly-skilled, experienced and qualified team who never compromise on the quality of products.</li>
                <li>State of the art infrastructure, advanced tools and machinery for large production.</li>
            </ul>
            <p>All the products are checked by different parameters before supplying in order to provide defect-free products to the customers.</p>
            <p>Contact us on 9922941689 or Email marketing@swajit.com.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DragFlowConveyorChain;
